const N_THETA = 60;

export function gridFaces(nRows, nCols, offset = 0) {
  const fi = [], fj = [], fk = [];
  for (let r = 0; r < nRows - 1; r++) {
    for (let c = 0; c < nCols - 1; c++) {
      const a = offset + r * nCols + c;
      const b = offset + r * nCols + c + 1;
      const c0 = offset + (r + 1) * nCols + c;
      const d = offset + (r + 1) * nCols + c + 1;
      fi.push(a, b); fj.push(b, d); fk.push(c0, c0);
    }
  }
  return { fi, fj, fk };
}

export function bladeMesh(surf, nBlades, color, name, opacity) {
  const nSpans = surf.x.length;
  const nPts = surf.x[0].length;
  const nVerts = nSpans * nPts;
  const X = [], Y = [], Z = [];
  const I = [], J = [], K = [];

  for (let b = 0; b < nBlades; b++) {
    const angle = (2 * Math.PI * b) / nBlades;
    const ca = Math.cos(angle), sa = Math.sin(angle);
    const offset = b * nVerts;

    for (let r = 0; r < nSpans; r++) {
      for (let c = 0; c < nPts; c++) {
        const x = surf.x[r][c], y = surf.y[r][c];
        X.push(x * ca - y * sa);
        Y.push(x * sa + y * ca);
        Z.push(surf.z[r][c]);
      }
    }

    const { fi, fj, fk } = gridFaces(nSpans, nPts, offset);
    I.push(...fi); J.push(...fj); K.push(...fk);
  }

  return {
    type: "mesh3d",
    x: X, y: Y, z: Z,
    i: I, j: J, k: K,
    color, opacity,
    name, showlegend: true, hoverinfo: "skip",
    lighting: { ambient: 0.55, diffuse: 0.85, specular: 0.25, roughness: 0.45, fresnel: 0.15 },
    lightposition: { x: 1, y: 1, z: 2 },
    flatshading: false,
  };
}

export function revolutionMesh(r, z, color, name, opacity) {
  const nR = r.length;
  const X = [], Y = [], Z = [];

  for (let ti = 0; ti < N_THETA; ti++) {
    const t = (2 * Math.PI * ti) / (N_THETA - 1);
    for (let ri = 0; ri < nR; ri++) {
      X.push(r[ri] * Math.cos(t));
      Y.push(r[ri] * Math.sin(t));
      Z.push(z[ri]);
    }
  }

  const { fi, fj, fk } = gridFaces(N_THETA, nR);

  return {
    type: "mesh3d",
    x: X, y: Y, z: Z,
    i: fi, j: fj, k: fk,
    color, opacity,
    name, showlegend: true, hoverinfo: "skip",
    lighting: { ambient: 0.5, diffuse: 0.7, specular: 0.1, roughness: 0.6 },
    lightposition: { x: 1, y: 1, z: 2 },
    flatshading: false,
  };
}
